import { Link } from 'react-router';

import { pricingFieldLabels } from '../lib/pricing-readiness-labels';

export interface PricingReadinessAlertProps {
  readonly missingFields: string[];
  readonly ticketId: string | null;
  readonly testId: string;
}

export function PricingReadinessAlert({
  missingFields,
  ticketId,
  testId,
}: PricingReadinessAlertProps) {
  return (
    <div
      className="border-destructive/40 bg-destructive/5 text-destructive rounded-md border p-3 text-sm"
      role="alert"
      data-testid={testId}
    >
      <p className="font-medium">Pricing inputs are missing on the parent ticket.</p>
      <p className="text-muted-foreground mt-1 text-xs">
        Populate {pricingFieldLabels(missingFields)} on the ticket before raising this invoice.
        {ticketId !== null && (
          <>
            {' '}
            <Link
              to={`/tickets/${ticketId}/edit`}
              className="text-primary underline underline-offset-2"
              data-testid={`${testId}-link`}
            >
              Open ticket to edit
            </Link>
          </>
        )}
      </p>
    </div>
  );
}
